import React, { Component } from 'react';

import _compact from 'lodash/compact';
import _find from 'lodash/find';
import _get from 'lodash/get';
import _includes from 'lodash/includes';
import _map from 'lodash/map';
import _merge from 'lodash/merge';
import _trim from 'lodash/trim';

import alert from 'react-hot-toast';

import NotificationForm from './NotificationForm';
import { withContext } from './NotificationContext';
import {messageService} from '../../services';
import { redirectTo, handleCountTopicSelected, CONSTANTS } from '../../utils/common';
import messages from './messages.json';

export const buildTitleField = (rawValue) => {
  const value = rawValue || '';
  const isValid = _trim(value).length > 0;
  const error = isValid ? '' : messages.ink.notification.title.required;

  return { value, isValid, error };
};

class EditNotification extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showForm: true,
      id: _get(props, 'id', null),
    }
  }

  async componentDidMount() {
    const { id } = this.state;
    if(!id) return;

    const message = await messageService.getMessage(id);
    let {rootTopic, updateState, sectionList} = this.props.context;
    rootTopic = this._processTargeting(rootTopic, message.targeting, sectionList);
    const numberTopicSelected = handleCountTopicSelected(rootTopic.children);
    rootTopic.children.forEach(child => {
      if (numberTopicSelected >= CONSTANTS.max_topic_num || child.selected) {
        child.disable(true)
      } else {
        child.unDisable(true);
      }
    });
    
    updateState({
      currentMessage: {
        id,
        title: buildTitleField(message.title),
        body: {
          value: message.body,
          isValid: true,
        },
        directUrl: {
          value: _get(message, 'directUrl', ''),
        },
        isIncludeImage: _get(message, 'isIncludeImage', false),
        targeting: message.targeting,
        article: message.article,
        campaignIds: _get(message, 'campaignIds') || [],
        // WWW-15236 — preload scheduling so editing a scheduled push reopens with
        // "Send later" + its time, and can be rescheduled or cancelled.
        scheduledSendTime: _get(message, 'scheduledSendTime', null),
        brazeScheduleIds: _get(message, 'brazeScheduleIds', null),
      },
      rootTopic,
    });
  }

  handleCancel = () => {
    this.setState({
      showForm: false,
    });
    this.props.closeEditNotification();
  };

  handlePublish = () => {
    this.setState({
      showForm: false,
    });
  }

  handleUpdate = async (data, showSuccessAlert) => {
    try {
      const message = await this._save(data);
      if(showSuccessAlert) {
        this.handleCancel();
        alert(messages.ink.notification.save.success);
      }
      return message;
    } catch(err) {
      alert.error(messages.ink.notification.save.failure);
    }
  };

  render() {
    if(this.state.showForm) {
      return <NotificationForm
        show={this.state.showForm}
        onSave={this.handleUpdate}
        onHide={this.handleCancel}
        onDone={this.handlePublish}
      />
    } else {
      this.props.closeEditNotification();
      return redirectTo('/notifications');
    }
  }

  _save = data => {
    const {currentMessage} = this.props.context;
    return messageService.updateMessage(currentMessage.id, data);
  }

  _processTargeting(rootTopic, targeting, sectionList) {
    const type = _get(targeting, 'targetType.label');
    // only the 'Topic' target type needs special processing
    if('Topic' !== type) return rootTopic;
    let section = this._processSectionList(sectionList, targeting.selected)

    let arr = _map(section, item => {
      const node = _find(rootTopic.children, child => child.key === item.key);
      return node ? _merge(node, item) : null;
    });
    arr = _compact(arr);

    rootTopic.children = arr;
    return rootTopic;
  }

  _processSectionList(sectionList, selected) {

    if(sectionList.length > 0) {
        sectionList.forEach(
          section => {
            section.selected = _includes(selected,  section.key);
            this._processSectionList(section.children, selected);
          }
        )
    }

    return sectionList;
  }

}

export default withContext(EditNotification);
